/**
 * Replaces {{TOKEN_NAME}} placeholders in AI-generated card text with real values.
 * Replacement is intentionally client-side so participant names are never
 * stored inside AI-generated content on the server.
 */
export function resolveTokens(
  text: string,
  tokens: Record<string, string>,
): string {
  return Object.entries(tokens).reduce(
    (result, [key, value]) => result.replaceAll(`{{${key}}}`, value),
    text,
  );
}
